interface QuestionAnswer {
  answer: boolean | 0 | 1;
  note?: string | null | undefined;
}

interface Props {
  slug: string;
  question: string;
  description: string;
  required: boolean;
  isAcknowledgement: boolean;
  value: QuestionAnswer | undefined;
  onChange: (slug: string, value: QuestionAnswer) => void;
}

export function CheckinQuestion({
  slug,
  question,
  description,
  required,
  isAcknowledgement,
  value,
  onChange,
}: Props) {
  const answered = value !== undefined;
  const isYes = answered && (value.answer === true || value.answer === 1);
  const isNo = answered && (value.answer === false || value.answer === 0);

  const handleYes = () => {
    onChange(slug, { answer: true, note: value?.note ?? undefined });
  };

  const handleNo = () => {
    onChange(slug, { answer: false, note: value?.note ?? undefined });
  };

  const handleNote = (note: string) => {
    if (value !== undefined) {
      onChange(slug, { ...value, note: note || undefined });
    }
  };

  return (
    <div className="space-y-3 rounded-xl border border-border bg-surface/60 p-4">
      <div>
        <p className="text-base font-medium leading-snug">
          {question}
          {required && (
            <span className="ml-1 text-destructive" aria-hidden="true">
              *
            </span>
          )}
        </p>
        {description && <p className="mt-0.5 text-sm text-muted-foreground">{description}</p>}
      </div>

      <div className="flex gap-3">
        <button
          type="button"
          onClick={handleYes}
          className={[
            'flex-1 rounded-lg border px-4 py-3 text-sm font-medium transition-colors press',
            isYes
              ? 'border-primary bg-primary text-primary-foreground'
              : 'border-border bg-surface text-foreground',
          ].join(' ')}
        >
          {isAcknowledgement ? 'I confirm' : 'Yes'}
        </button>
        <button
          type="button"
          onClick={handleNo}
          className={[
            'flex-1 rounded-lg border px-4 py-3 text-sm font-medium transition-colors press',
            isNo
              ? 'border-destructive bg-destructive/10 text-destructive'
              : 'border-border bg-surface text-foreground',
          ].join(' ')}
        >
          {isAcknowledgement ? 'I do not confirm' : 'No'}
        </button>
      </div>

      {answered && !isYes && (
        <div>
          <label
            htmlFor={`note-${slug}`}
            className="mb-1 block text-[10.5px] font-medium uppercase tracking-[0.14em] text-muted-foreground"
          >
            Optional note
          </label>
          <textarea
            id={`note-${slug}`}
            rows={2}
            value={value.note ?? ''}
            onChange={(e) => handleNote(e.target.value)}
            placeholder="Any extra detail for our staff…"
            className="w-full resize-none rounded-lg border border-border bg-surface px-3 py-2.5 text-sm outline-none focus:ring-2 focus:ring-ring/30"
          />
        </div>
      )}
    </div>
  );
}
